import React from "react"
import PropTypes from "prop-types"
import {Box, useTheme} from "@mui/material"
import Content from "../../components/Content"
import {checkVisibility} from "../../misc/precondition-evaluation"

export const containerColumnLayoutPrototype = [
    {key: "spacing", type: "INTEGER", label: "Spacing (px)", size: 6},
    {key: "columnsXs", type: "STRING", label: "Spalten Xs (z.B. \"12\" oder \"3,9\")", size: 6},
    {key: "columnsSm", type: "STRING", label: "Spalten Sm", size: 6},
    {key: "columnsMd", type: "STRING", label: "Spalten Md", size: 6},
    {key: "columnsLg", type: "STRING", label: "Spalten Lg", size: 6},
    {key: "columnsXl", type: "STRING", label: "Spalten Xl", size: 6},
]

const parseColumns = (raw) => {
    if (Array.isArray(raw)) return raw.map(Number).filter(n => n > 0)
    if (typeof raw === "string" && raw.trim()) return raw.split(",").map(s => Number(s.trim())).filter(n => n > 0)
    return null
}

const buildTemplate = (cols) => cols.map(n => `${n}fr`).join(" ")

const ContainerColumnLayout = ({container, disabled, getDataFromPointer}) => {
    const theme = useTheme()
    const breakpoints = [
        ["xs", parseColumns(container.columnsXs)],
        ["sm", parseColumns(container.columnsSm)],
        ["md", parseColumns(container.columnsMd)],
        ["lg", parseColumns(container.columnsLg)],
        ["xl", parseColumns(container.columnsXl)],
    ]
    const xsCols = breakpoints[0][1] ?? [12]
    const sx = {
        display: "grid",
        gap: `${container.spacing ?? 0}px`,
        gridTemplateColumns: buildTemplate(xsCols),
        minWidth: container?.minWidth
    }
    breakpoints.slice(1).forEach(([bp, cols]) => {
        if (cols) {
            sx[theme.breakpoints.up(bp)] = {gridTemplateColumns: buildTemplate(cols)}
        }
    })
    return (
        <Box sx={sx}>
            {container.children
                .filter(child => checkVisibility(child, getDataFromPointer))
                .map(child => (
                    <Content
                        key={child.id}
                        child={child}
                        disabled={disabled}
                    />
                ))}
        </Box>
    )
}

ContainerColumnLayout.propTypes = {
    container: PropTypes.shape({
        spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        columnsXs: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        columnsSm: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        columnsMd: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        columnsLg: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        columnsXl: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        children: PropTypes.array,
    }),
    disabled: PropTypes.bool,
    getDataFromPointer: PropTypes.func,
}

export default ContainerColumnLayout
